import axios from 'axios';
import { useErrorAlert } from './ErrorAlertProvider';
import { safeFalsy } from '../components/util/UtilFunctions';

const keyNames = {
  UK_Account: {
    objectName: 'Account',
    descriptor: 'name',
  },
  UK_AddressType_AddressTypeName: {
    objectName: 'Address type',
    descriptor: 'name',
  },
  UK_Contact: {
    objectName: 'Contact',
    descriptor: 'name',
  },
  UK_ContactAddress: {
    objectName: 'Contact address',
    descriptor: 'contact and address types',
  },
  UK_DealStatus_Name: {
    objectName: 'Deal status',
    descriptor: 'name',
  },
  UK_Invitation: {
    objectName: 'Invitation',
    descriptor: 'email',
  },
  UK_OrgRole: {
    objectName: 'Org role',
    descriptor: 'name',
  },
  UK_Perm_Name: {
    objectName: 'Permission',
    descriptor: 'name',
  },
  UK_Perm_PermEnum: {
    objectName: 'Permission',
    descriptor: 'enum',
  },
  UK_ReportTemplate: {
    objectName: 'Report template',
    descriptor: 'name and type',
  },
  UK_TranCategory: {
    objectName: 'Transaction category',
    descriptor: 'code',
  },
  UqUserOrg: {
    objectName: 'User',
    descriptor: 'Id',
  },
  UK_UserOrgRole: {
    objectName: 'User org role',
    descriptor: 'Id',
  },
  UK_ContactDlm_DlmContactId: {
    objectName: 'Contact',
    descriptor: 'Id',
  },
  UK_InvoiceDlm_DlmVoucherId: {
    objectName: 'Invoice',
    descriptor: 'Id',
  },
  UK_InvoiceLineItemDlm_DlmVoucherTranId: {
    objectName: 'Transaction',
    descriptor: 'Id',
  },
  UK_InvoiceType_DlmVoucherTypeId: {
    objectName: 'Transaction',
    descriptor: 'Id',
  },
};

const getDuplicateKeyObjString = sqlMessage => {
  try {
    const indexName = sqlMessage.split('key ')[1].replace(/'/g, '');
    const friendlyNames = keyNames[indexName];
    const { objectName, descriptor } = friendlyNames;
    return `${objectName} already exists with the same ${descriptor}`;
  } catch (e) {
    console.error(e);
  }
  return 'An object already exists with a matching unique field';
};

const StatusInterceptor = () => {
  const handleAlert = useErrorAlert();
  axios.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      const { response } = error;

      const deeplinkRoutes = [
        'contact-xero-deeplink',
        'voucher-xero-deeplink',
        'trancat-xero-deeplink',
      ];

      const { url } = response.config;

      const isDeepLink = deeplinkRoutes.includes(
        url.split('/')[url.split('/').length - 2],
      );

      if (response.status === 568) {
        console.log(response);

        handleAlert(`${safeFalsy(error.response.data)}`, '#d32f30');
      } else if (response.status === 569) {
        const dupObj = getDuplicateKeyObjString(response.data);
        handleAlert(dupObj, '#d32f30');
      } else if (response.status === 500 && isDeepLink) {
        return;
      } else {
        console.log(response);
        console.log('ELSE!');

        handleAlert(
          `${safeFalsy(error.response.status)} ${safeFalsy(
            error.response.status === 403
              ? 'You are not authorized for this action'
              : error.response.data,
          )}`,

          '#d32f30',
        );

        // TODO: UNCOMMENT:
        // error.response.status === 403
        //   ? (window.location.assign(`${process.env.REACT_APP_DOMAIN}/`),
        //     handleAlert('You are not authorized for this action', '#d32f30'))
        //   : handleAlert(
        //       `${safeFalsy(error.response.status)} ${safeFalsy(
        //         error.response.data,
        //       )}`,
        //       '#d32f30',
        //     );
      }

      return Promise.reject(error);
    },
  );

  return null;
};

export default StatusInterceptor;
